<template>
  <div>
    <v-row class="my-4">
      <v-col cols="12" md="6">
        <v-text-field v-model="controller.port" label="Порт" readonly dense />
        <v-text-field
          v-model="modificationDate"
          label="Дата последнего изменения"
          readonly
          dense
          class="py-1"
        />
        <v-text-field
          v-model="controller.accessPoint.name"
          label="Точка доступа"
          readonly
          dense
        />
        <v-text-field
          v-model="controller.typeName"
          label="Тип"
          readonly
          dense
        />
      </v-col>

      <v-col cols="12" md="6">
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Название</th>
              <th>Активный</th>
              <th>Архивный</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="gateway in controller.gateways" :key="gateway.id">
              <td>{{ gateway.name }}</td>
              <td>
                <v-checkbox v-model="gateway.active" readonly class="ma-0" />
              </td>
              <td>
                <v-checkbox v-model="gateway.archival" readonly class="ma-0" />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ControllerInfo",
  props: { controller: { required: true } },
  computed: {
    modificationDate() {
      if (this.controller.modification === null) return null;
      return new Date(this.controller.modification).toLocaleString("ru-Ru");
    }
  },
  created() {
    this.controller.gateways.sort((a, b) => (a.name > b.name ? 1 : -1));
  }
};
</script>
